<script setup lang="ts">
import Button from 'primevue/button'
import type { RouteLocationRaw } from 'vue-router'
import DEmptyComponent from './DEmptyComponent.vue'
import { NuxtLink } from '#components'
import { Loader2 } from 'lucide-vue-next'
import { cn } from '~/lib/utils'

const props = withDefaults(
  defineProps<{
    loading?: boolean
    disabled?: boolean
    size?: 'small' | 'large'
    to?: RouteLocationRaw
    href?: string
    target?: string
    download?: string
    outlined?: boolean
    text?: boolean
    plain?: boolean
    class?: string
    tooltipString?: string
  }>(),
  {
    loading: false,
    disabled: false,
  }
)

const { loading, disabled } = toRefs(props)
</script>

<template>
  <component
    :is="to || href ? (href ? 'a' : NuxtLink) : DEmptyComponent"
    :to="to"
    :href="href"
    :target="target"
    :download="download"
  >
    <Button
      :disabled="disabled || loading"
      :size="size"
      :outlined="outlined"
      :text="text"
      :plain="plain"
      :class="cn('py-1 px-2 text-sm gap-0 h-8', props.class)"
      v-tooltip="tooltipString"
      v-bind="$attrs"
    >
      <slot name="laoding">
        <template v-if="loading"
          ><Loader2 class="w-4 h-4 mr-2 animate-spin"
        /></template>
      </slot>
      <slot> </slot>
    </Button>
  </component>
</template>
